<!-- 联系客服功能 -->
<template>
  <div>
    <div
      style="cursor: pointer;display: flex;align-items: center;line-height: 22px;"
      @click="contactService"
    >
      <img
        src="@assets/images/headset-one.svg"
        alt=""
        style="margin-right: 4px;"
      >
      联系客服
    </div>
  </div>
</template>

<script>
import { useZhichiService } from '../../../utils/use-zhichi-service';

export default {
    name: "ContactService",
    data() {
        return {
            openZhichiService: ()=>{},
        };
    },
    created() {
        const { openZhichiService } = useZhichiService();
        this.openZhichiService = openZhichiService
    },
    methods: {
        contactService() {
            this.openZhichiService();
        }
    }
}
</script>

<style>

</style>
